<template>
  <site-header />
</template>

<script>
import SiteHeader from '@/components/home/SiteHeader.vue'

export default {
  name: 'Header',
  components: { SiteHeader }
}
</script>
